import { resetUserLogin } from "screens/Root/actions/appActions";
import { closeContentTab, reloadContentTab } from "screens/Root/actions/contentTabActions";
import { useNotifications } from "screens/Root/features/NotificationIcons/useNotifications";
import { useDispatch } from "react-redux";
import { setContentModified, clearPatientFromTab, setContentTitle, setReadyToAutoLogout, } from "../../features/slices/rootSlice";
export const useContentTabs = () => {
    const dispatch = useDispatch();
    const { updateNotifications } = useNotifications();
    const closeCurrent = () => {
        closeContentTab();
    };
    const close = (key) => {
        dispatch(closeContentTab(key));
    };
    const setModified = (key, modified) => {
        dispatch(setContentModified({ key, modified }));
    };
    const closeAllAndReset = async () => {
        window.RootExtensions.FullSearchWindow.close();
        await dispatch(resetUserLogin());
        await updateNotifications(true);
    };
    const clearCurrentTabsPatient = () => dispatch(clearPatientFromTab());
    const setTabTitle = (title, key) => {
        dispatch(setContentTitle({ title, key }));
    };
    const reload = (disableCache) => {
        dispatch(reloadContentTab(disableCache));
    };
    const readyToAutoLogout = (key) => {
        dispatch(setReadyToAutoLogout(key));
    };
    return {
        closeCurrent,
        close,
        setModified,
        closeAllAndReset,
        reload,
        setTabTitle,
        clearCurrentTabsPatient,
        readyToAutoLogout
    };
};
